module.exports = __webpack_public_path__ + "static/user-flow-1c94448e2547bb38494e02719affa94b.png";